import { render } from "./QueueMappingTab.vue?vue&type=template&id=9a0be9de&scoped=true"
import script from "./QueueMappingTab.vue?vue&type=script&lang=js"
export * from "./QueueMappingTab.vue?vue&type=script&lang=js"

import "./QueueMappingTab.vue?vue&type=style&index=0&id=9a0be9de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a0be9de"]])

export default __exports__